import styled from 'styled-components';

export const WrapperDiv = styled.div(
  props => `
  display:flex;
  background-color: ${props.theme.colors.goBrandBlue.medium};
  width: 100%;
  position: sticky;
  top: calc(148px + ${props.filterHeight}px);
  left: 0;
  z-index: ${props.theme.misc.zIndex.xxsmall};
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  border-bottom-right-radius:0;
  border-bottom-left-radius:0;
  align-items:center;
`,
);

export const WrapperDivUpsellHeader = styled.div(
  props => `
    display:flex;
    background-color: ${props.theme.colors.goBrandBlue.medium};
    width: 100%;
    height: 64px;
    position: sticky;
    top: 150px;
    left: 0;
    z-index: ${props.theme.misc.zIndex.xxsmall};
    border-radius: '0px';    
    box-shadow: ${props.showFilters ? '0px 2px 4px rgba(0, 0, 0, 0.17447)' : 'none'};
`,
);

export const WrapperDivUpsellFilter = styled.div(
  props => `
    display:flex;
    width: 100%;
    height: 64px;
    margin-top: -20px;
    z-index: ${props.theme.misc.zIndex.xxsmall};
    border-radius: '0px';    
    box-shadow: ${props.showFilters ? '0px 2px 4px rgba(0, 0, 0, 0.17447)' : 'none'};
`,
);

export const TextStylingWrapperSpan = styled.p(
  props => `
  font-size: ${props.theme.font.custom(16)};
  font-weight: 600;
  color:${props.theme.colors.downriver.base};
  text-align: center;
`,
);

export const ItemWrapperDivUpsell = styled.div(
  props => `
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.custom(30)};
  display: flex;
  align-items: center;
  border-left: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  flex:${!props.isUpsellWithMultiroom ? (props.isCustomFlex ? '1.38' : '1') : ''};
  width:${props.width || ''};
  flex-shrink:${props.isUpsellWithMultiroom ? 0 : ''};
  &:first-child {
    border-left: none;
  }
`,
);

export const ItemWrapperDiv = styled.div(
  props => `
  padding: ${props.theme.spacing.xlarge};
  border-right: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  &:last-child {
    border-right: none;
  }
  flex:${!props.isUpsellWithMultiroom ? (props.isCustomFlex ? '1.38' : '1') : ''};
  width:${props.width || ''};
  flex-shrink:${props.isUpsellWithMultiroom ? 0 : ''};
`,
);

export const FilterBtn = styled.div(
  props => `
  position: absolute;
  padding-left: 4px;
  top: 0px;
  right: -${props.offsetValue}px;
  width: ${props.offsetValue}px;
  height: 64px;
  background-color: ${
    props.showFilters
      ? props.isScrolling
        ? props.theme.colors.goBrandBlue.medium
        : 'white'
      : 'white'
  };
  display: flex;
  align-items: center;
  &:before {
    position: absolute;
    content: "";
    top: 9.5px;
    left: -23px;
    width: 45px;
    height: 45px;
    border-radius: 0px 0px 0px 8px;
    transform: rotate(45deg);
    background-color: ${
      props.showFilters
        ? props.isScrolling
          ? props.theme.colors.goBrandBlue.medium
          : 'white'
        : 'white'
    };
  }
  `,
);

export const FilterTag = styled.div(
  props => `
  cursor: pointer;
  position: relative;
  display: flex;
  padding-left: 7px;
  align-items: center;
  padding: 0px 10px 0px 7px;
  height: 37px;
  background-color: ${
    props.showFilters
      ? props.isScrolling
        ? 'white'
        : '#2276E3'
      : props.isScrolling
        ? '#D1E5FF'
        : '#2276E3'
  };
  border-radius: 8px;
  &:before {
    position: absolute;
    top: 7px;
    left: -9.5px;
    content: "";
    width: 23px;
    height: 23px;
    transform: rotate(45deg);
    border-radius: 0px 0px 0px 8px;
    background-color: ${
      props.showFilters
        ? props.isScrolling
          ? 'white'
          : '#2276E3'
        : props.isScrolling
          ? '#D1E5FF'
          : '#2276E3'
    };
  }

  > p {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  > p > span:first-child {
    margin-right: 5px;
    width: 1rem;
    height: 1rem;
    border-left: 2px ${props.isScrolling ? '#2276E3' : 'white'} solid;
    border-bottom: 2px ${props.isScrolling ? '#2276E3' : 'white'} solid;
    transform: rotate(45deg);
  }

  > p > span:last-child {
    color: ${
      props.showFilters
        ? props.isScrolling
          ? '#2276E3'
          : 'white'
        : props.isScrolling
          ? '#2276e3'
          : 'white'
    };
    font-size: 16px;
    font-weight: 600;
  }
`,
);
